module.exports = __webpack_public_path__ + "img/card-b4.0a1a08a1.png";